/// <reference path="app.hilo.controllers.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../../common/controllers/screencontrollerbase.ts" />
module App.HiLO.Controllers {

    'use strict';

    class SubmissionCompleteController extends App.Common.Controllers.ScreenControllerBase {
        public static $inject = ['$injector'];
        public busyPromise: angular.IPromise<any>;
        public id: string;
        public product: string;

        constructor($injector: angular.auto.IInjectorService) {
            super($injector);
            this.title = 'Property Consents';
            this.id = this.$stateParams['id'];
            this.product = this.getProduct(this.$stateParams['product']);

            this.busyPromise = this.$q.resolve();

        }
        4
        public getProduct(id): string {
            var name;
            switch (id) {
                case '1':
                    name = 'Permission to carry out works';
                    break;
                case '2':
                    name = 'Release mortgage or legal charge';
                    break;
                case '3':
                    name = 'Permission to sell or lease property';
                    break;
                default:
                    name = '';
                    break;
            }

            return name;
        }

        public beforeInitialize(): angular.IPromise<any> {
            return this.setAuthenticationRequired(false);
        }

        public initialize(): angular.IPromise<any> {
            return this.$q.resolve();
        }

    }


    angular
        .module('app.hilo.controllers')
        .controller('app.hilo.controllers.submissionCompleteController', SubmissionCompleteController);

}